var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#291640;stroke-miterlimit:10;}")),React.createElement("title",{"key":1},"Asset 33"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_2-2","data-name":"Layer 2"},React.createElement("polyline",{"style":{"fill":"none","stroke":"#291640","strokeMiterlimit":"10"},"points":"0.35 0.35 2.24 2.24 4.1 0.38"})))]);
}

Arrow.defaultProps = {"viewBox":"0 0 4.46 2.95"};

module.exports = Arrow;

Arrow.default = Arrow;
